import React from 'react';
import { Box, useTheme } from '@mui/material';
import { pulse } from '@styles/animations';

import type { ThinkingDotsProps } from './StatusIndicator.types';

const DOT_SIZES = {
  sm: 6,
  md: 8,
  lg: 10,
};

const DOT_GAPS = {
  sm: 0.4,
  md: 0.5,
  lg: 0.6,
};

/**
 * Three pulsing dots to indicate thinking/processing state
 * Uses staggered animation delays for wave effect
 */
export const ThinkingDots: React.FC<ThinkingDotsProps> = ({ size = 'md', color }) => {
  const theme = useTheme();
  const dotColor = color || theme.palette.chat.colors.thinkingDot;
  const dotSize = DOT_SIZES[size];
  const dotGap = DOT_GAPS[size];

  const dotStyle = {
    width: dotSize,
    height: dotSize,
    borderRadius: '50%',
    background: theme.palette.chat.gradients.ai,
    animation: `${pulse} 1.5s infinite ease-in-out`,
  };

  return (
    <Box sx={{ display: 'flex', gap: dotGap, ml: 1, alignItems: 'center' }}>
      <Box sx={{ ...dotStyle, animationDelay: '0s' }} />
      <Box sx={{ ...dotStyle, animationDelay: '0.3s' }} />
      <Box sx={{ ...dotStyle, animationDelay: '0.6s' }} />
    </Box>
  );
};
